/*
  STADION - Buy now, pay later
  Recalculates the instalment amounts when the visitor picks a different
  variant, so a price change on a size or a colour is reflected straight away.
  No module imports on purpose - this runs standalone on every product page.
*/
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace('{{amount}}', whole + '.' + parts[1]);
  }

  function update(root, price) {
    var format = root.getAttribute('data-money-format') || '\u00a3{{amount}}';
    var rows = root.querySelectorAll('[data-bnpl-row]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var count = parseInt(row.getAttribute('data-bnpl-row'), 10);
      var min = parseInt(row.getAttribute('data-bnpl-min') || '0', 10);
      var max = parseInt(row.getAttribute('data-bnpl-max') || '0', 10);
      var eligible = price >= min && (max === 0 || price <= max);
      row.hidden = !eligible;
      if (!eligible) continue;
      var amount = row.querySelector('[data-bnpl-amount]');
      if (amount) amount.textContent = formatMoney(Math.round(price / count), format);
    }
    var visible = root.querySelectorAll('[data-bnpl-row]:not([hidden])');
    root.hidden = visible.length === 0;
  }

  function init(root) {
    var prices = {};
    try {
      prices = JSON.parse(root.getAttribute('data-variant-prices') || '{}');
    } catch (e) {
      prices = {};
    }

    var scope = root.closest('.shopify-section') || document;
    scope.addEventListener('variant:update', function (event) {
      var variant = event.detail && event.detail.resource;
      if (!variant || !variant.id) return;
      var price = prices[String(variant.id)];
      if (typeof price === 'number') update(root, price);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-stadion-bnpl]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].dataset.stadionBnplReady) continue;
      roots[i].dataset.stadionBnplReady = '1';
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
